import AppContext from "PFApp/app_context";
import ToggleableText from "PFComponents/toggleable_text/toggleable_text";
import React, { useContext } from "react";

import { ProfilePreviewHeader } from "./profile_preview_header";

const ProfilePreviewSummary = () => {
  const {
    profilePreview: { ready, profile }
  } = useContext(AppContext).store;

  if (!ready || !profile || !profile.summary) {
    return false;
  }

  return (
    <div data-qa-id="ProfilePreviewSummary">
      <ProfilePreviewHeader>Bio</ProfilePreviewHeader>
      <ToggleableText text={profile.summary} />
    </div>
  );
};

export default ProfilePreviewSummary;
